import {LayoutModule} from '@angular/cdk/layout';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatCardModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatDialogModule,
	MatDividerModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSelectModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatTooltipModule
} from '@angular/material';
import {TranslateModule} from '@ngx-translate/core';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {QRCodeModule} from 'angularx-qrcode';
import {MaxNgLibModule} from 'max-ng-lib';
import {CoreModule} from '../../../../core/core.module';
import {PartialsModule} from '../../../partials/partials.module';
import {BaseDadosComponent} from './base-dados/base-dados.component';
import {ConexoesComponent} from './conexoes/conexoes.component';
import {ConfiguracaoContaEmailComponent} from './configuracao-conta-email/configuracao-conta-email.component';
import {FerramentasRoutingModule} from './ferramentas-routing.module';
import {ImportarLocalizacaoErpComponent} from './importar-localizacao-erp/importar-localizacao-erp.component';
import {LogoEmpresaComponent} from './logo-empresa/logo-empresa.component';
import {ConfiguracaoTimelineWhatsappComponent} from './configuracao-timeline-whatsapp/configuracao-timeline-whatsapp.component';
import {ColorPickerModule} from 'ngx-color-picker';
import { ConfiguracaoRastreadoresComponent } from './configuracao-rastreadores/configuracao-rastreadores.component';


@NgModule({
	imports: [
		CommonModule,
		CoreModule,
		MatDialogModule,
		HttpClientModule,
		PartialsModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatSlideToggleModule,
		MatDividerModule,
		LayoutModule,
		MaxNgLibModule,
		NgxDatatableModule,
		QRCodeModule,
		FerramentasRoutingModule,
		ColorPickerModule
	],
	declarations: [
		ConfiguracaoContaEmailComponent,
		BaseDadosComponent,
		LogoEmpresaComponent,
		ImportarLocalizacaoErpComponent,
		ConexoesComponent,
		ConfiguracaoTimelineWhatsappComponent,
		ConfiguracaoRastreadoresComponent,
	]
})
export class FerramentasModule {
}
